import React from 'react'
import { Link,useHistory  } from 'react-router-dom'
import {VStack,HStack,Divider,Text,Pressable,Stack,InputLeftElement,Input,Center,
Button} from 'native-base'
import {setUser,getUser} from '../../helper/authentication'
import '../../App.css'


export default function SignInPage() {
     const [show, setShow] = React.useState(false);
     const [isLoading,setIsLoading] = React.useState(false);
     const [username, setUsername] = React.useState();
     const [password, setPassword] = React.useState();

const history = useHistory();


React.useEffect(()=>{

     if (getUser().isLoggedIn){
        const push_url = localStorage.getItem('prev_url') || '/collections'
        history.push(push_url);
      }

},[])


const login = ()=>{
setIsLoading(true)
// verify username and password

const userAuthenticated = true
if (userAuthenticated){
    setUser({Username:username.slice(0,5),Email:username,isLoggedIn:true})
}

setIsLoading(false)

history.push( localStorage.getItem('prev_url') || '/collections');
}


    return ( getUser().isLoggedIn ? <Center> Already Logged In, Redirecting .... </Center>:
        <VStack my={'3rem'}  >
        <Center>
        <VStack space={3} w={{lg:'23%',md:'50%',sm:'99%'}} justifyContent='center'    >
                 <Text my={4} textAlign='center' fontSize='23px' > Login to PromptDesk </Text>

             <Stack space={5} w="100%" alignItems="center">
      <Input w={{
      base: "75%",
      md: "100%"
    }} borderColor='silver' onChangeText={e=>setUsername(e)}  fontSize='14px' bg='#134e4a00'  h="44px" InputLeftElement={
        <svg height="24px" width="24px" className='m-2' viewBox="0 0 512 512" xmlSpace="preserve" fill="#FFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">  <g> <path class="st0" d="M440.917,67.925H71.083C31.827,67.925,0,99.752,0,139.008v233.984c0,39.256,31.827,71.083,71.083,71.083 h369.834c39.255,0,71.083-31.827,71.083-71.083V139.008C512,99.752,480.172,67.925,440.917,67.925z M178.166,321.72l-99.54,84.92 c-7.021,5.992-17.576,5.159-23.567-1.869c-5.992-7.021-5.159-17.576,1.87-23.567l99.54-84.92c7.02-5.992,17.574-5.159,23.566,1.87 C186.027,305.174,185.194,315.729,178.166,321.72z M256,289.436c-13.314-0.033-26.22-4.457-36.31-13.183l0.008,0.008l-0.032-0.024 c0.008,0.008,0.017,0.008,0.024,0.016L66.962,143.694c-6.98-6.058-7.723-16.612-1.674-23.583c6.057-6.98,16.612-7.723,23.582-1.674 l152.771,132.592c3.265,2.906,8.645,5.004,14.359,4.971c5.706,0.017,10.995-2.024,14.44-5.028l0.074-0.065l152.615-132.469 c6.971-6.049,17.526-5.306,23.583,1.674c6.048,6.97,5.306,17.525-1.674,23.583l-152.77,132.599 C282.211,284.929,269.322,289.419,256,289.436z M456.948,404.771c-5.992,7.028-16.547,7.861-23.566,1.869l-99.54-84.92 c-7.028-5.992-7.861-16.546-1.869-23.566c5.991-7.029,16.546-7.861,23.566-1.87l99.54,84.92 C462.107,387.195,462.94,397.75,456.948,404.771z"></path> </g> </g></svg>} placeholder="Email" />
     


      <Input w={{
      base: "75%",
      md: "100%"
    }}   borderColor='silver' onChangeText={e=>setPassword(e)}  fontSize='14px' bg='#134e4a00'  h="44px" type={show ? "text" : "password"} InputRightElement={<Pressable onPress={() => setShow(!show)}>
         { show ? <svg height="24px" width="24px" className='m-2' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> : <svg width="24px" height="24px" className='m-2'   viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>} 

          </Pressable>} placeholder="Password" />
                <Link  to="/forget-password"><Text className="right-label">Forget password?</Text></Link>

    </Stack>


              
                <p>
                    <Button id="sub_btn"  h="44px"  type="submit" 
                    onPress={login}  isLoading={isLoading} spinnerPlacement="end"  >
                    Login </Button>
                </p>
            <footer>
            <Center>
             <Text textAlign='center'  > Don’t have an account yet? <Pressable><a className='text-primary'  onClick={(e=>{
                e.preventDefault();
                history.push("/register")
             })}
             >Sign up</a></Pressable></Text>
              </Center>
                <Button my={6} variant='outline' textDecoration="none" ><Link textDecoration="none" to="/"><Text textDecoration="none" > Back to Homepage </Text></Link></Button>
            </footer>
        </VStack>
        </Center>

        </VStack>
    )
}
